// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VT8i","top":"styles_top__3tzEz"};